module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ecFyN"))).then(() => module.bundle.root('aVi2q'));